// import axios from "axios";
import secure_axios from "../../services/secure_axios";
// Defining initial state as a function
const initialState  = () => ({
  allcustomers: [],
  thiscustomer: {},
  blockedcustomers: [],
});

// define state
const state = initialState();

const getters = {
  allcustomers: (state) => state.allcustomers,
  thiscustomer: (state) => state.thiscustomer,
  blockedcustomers : (state) => state.blockedcustomers,
};

const mutations = {
  setAllCustomers(state, payload) {
    state.allcustomers = payload;
  },
  clearCustomers(state) {
    state.allcustomers = [];
  },
  setThisCustomer(state, payload) {
    state.thiscustomer = payload;
  },
  setblockedcustomers(state, payload){
    state.blockedcustomers = payload;
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getAllCustomers({ commit, getters }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const smandocno = payload.smandocno;
    const skip = payload.skip;
    const limit = payload.limit;
    const search = payload.search;

    secure_axios
      .get(
        `${getters.sessionAPI}customers?smandocno=${smandocno}&search=${search}&skip=${skip}&limit=${limit}`
      )
      .then((response) => {
        commit("setAllCustomers", response.data.customers);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  getThisCustomer({ commit, getters }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const doctype = payload.doctype;
    const docno = payload.docno;    

    secure_axios
      .get(`${getters.sessionAPI}customer?doctype=${doctype}&docno=${docno}`)
      .then((response) => {
        commit("setLoading", false);
        var customers = [];
        customers.push(response.data.customer);
        commit("setAllCustomers", customers);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  clearAllCustomers({ commit }) {
    commit("clearCustomers");
  },

  selectThisCustomer({ commit }, payload) {
    commit("setThisCustomer", payload);
  },
  setblockedcustomers({commit},payload){
    commit("setblockedcustomers",payload)
  }
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
